//Reference: EN035

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class WorkType extends Mappeable {

    idTypeJobPk: number;
    cdTypeJob: string;
    isActive: number;

    constructor(o) {
        super(o);
        this.isActive = this.isActive ??  0 
    }

    public mapToBack() {
        return {
            cdTypeJob: this.cdTypeJob,
            isActive: this.isActive ? 1 : 0
        }
    }
}